import { createIcon } from '@chakra-ui/icons';

export const SingleDocument = createIcon({
  displayName: 'SingleDocument',
  viewBox: '0 0 8 9',
  path: [
    <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5625 3.1001H3.6025"
        stroke="currentColor"
        strokeWidth="0.78"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5625 4.65991H5.9425"
        stroke="currentColor"
        strokeWidth="0.78"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5625 6.21997H5.9425"
        stroke="currentColor"
        strokeWidth="0.78"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 7V1.54C1 0.9654 1.4654 0.5 2.04 0.5H4.94472C5.08252 0.5 5.21512 0.5546 5.31236 0.65236L7.34764 2.68764C7.4454 2.7854 7.5 2.91748 7.5 3.05528V7C7.5 7.5746 7.0346 8.04 6.46 8.04H2.04C1.4654 8.04 1 7.5746 1 7Z"
        stroke="currentColor"
        strokeWidth="0.78"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.4536 2.83994H5.6804C5.39336 2.83994 5.1604 2.60698 5.1604 2.31994V0.552979"
        stroke="currentColor"
        strokeWidth="0.78"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  ],
});
